import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notice the role",
    opening: localizedGenderNode(
      [
      "Today I don't try to change the role.",
      "I just notice it.",
      "That is enough for now."
    ],
      [
      "Today I don't try to change the role.",
      "I just notice it.",
      "That is enough for now."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I feel I'm only listening?",
      "What is happening around me then?",
      "How does it feel in my body?"
    ],
      [
      "When do I feel I'm only listening?",
      "What is happening around me then?",
      "How does it feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Noticing the role is already a beginning."
    ],
      [
      "Noticing the role is already a beginning."
    ]
    ),
    action: localizedGenderNode(
      "one breath with the words \"I am here\".",
      "one breath with the words \"I am here\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What stays in me",
    opening: localizedGenderNode(
      [
      "Today I notice what stays in me after I listen.",
      "Without judgment.",
      "Just to see."
    ],
      [
      "Today I notice what stays in me after I listen.",
      "Without judgment.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my chest."
    ],
      [
      "I breathe slowly.",
      "I feel my chest."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I usually not say?",
      "What do I keep inside?",
      "How does it affect me?"
    ],
      [
      "What do I usually not say?",
      "What do I keep inside?",
      "How does it affect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "What stays in me matters."
    ],
      [
      "What stays in me matters."
    ]
    ),
    action: localizedGenderNode(
      "write one word about what stays.",
      "write one word about what stays."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Why I choose to listen",
    opening: localizedGenderNode(
      [
      "Today I ask why I choose to listen so much.",
      "Not criticism.",
      "Curiosity."
    ],
      [
      "Today I ask why I choose to listen so much.",
      "Not criticism.",
      "Curiosity."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I get when I listen?",
      "What am I afraid to lose if I speak?",
      "What is the need beneath it?"
    ],
      [
      "What do I get when I listen?",
      "What am I afraid to lose if I speak?",
      "What is the need beneath it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "There is a gentle reason behind the listening."
    ],
      [
      "There is a gentle reason behind the listening."
    ]
    ),
    action: localizedGenderNode(
      "name one small need.",
      "name one small need."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "A place for my voice",
    opening: localizedGenderNode(
      [
      "Today I check how to make room for my voice.",
      "Small.",
      "Safe."
    ],
      [
      "Today I check how to make room for my voice.",
      "Small.",
      "Safe."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my throat."
    ],
      [
      "I breathe slowly.",
      "I feel my throat."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where can I give myself space to speak?",
      "What am I afraid to say?",
      "What small step can I take?"
    ],
      [
      "Where can I give myself space to speak?",
      "What am I afraid to say?",
      "What small step can I take?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small place for my voice already changes something."
    ],
      [
      "A small place for my voice already changes something."
    ]
    ),
    action: localizedGenderNode(
      "write one sentence that wants to come out.",
      "write one sentence that wants to come out."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The fear of burdening",
    opening: localizedGenderNode(
      [
      "Today I notice the fear of burdening.",
      "Not to fight.",
      "Just to see."
    ],
      [
      "Today I notice the fear of burdening.",
      "Not to fight.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I afraid of when I share?",
      "What do I think will happen if I speak?",
      "How does this fear protect me?"
    ],
      [
      "What am I afraid of when I share?",
      "What do I think will happen if I speak?",
      "How does this fear protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Fear of burdening is also a wish to keep connection."
    ],
      [
      "Fear of burdening is also a wish to keep connection."
    ]
    ),
    action: localizedGenderNode(
      "tell myself \"I see you\".",
      "tell myself \"I see you\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "A small balance",
    opening: localizedGenderNode(
      [
      "Today I check how to create a small balance.",
      "Not perfect.",
      "Just small."
    ],
      [
      "Today I check how to create a small balance.",
      "Not perfect.",
      "Just small."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where do I give more than I receive?",
      "What would I like to receive a little more?",
      "What small step can I take?"
    ],
      [
      "Where do I give more than I receive?",
      "What would I like to receive a little more?",
      "What small step can I take?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small balance can return energy."
    ],
      [
      "A small balance can return energy."
    ]
    ),
    action: localizedGenderNode(
      "write one small request.",
      "write one small request."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Staying when I speak",
    opening: localizedGenderNode(
      [
      "Today I practice staying when I speak.",
      "Not disappearing.",
      "Just being."
    ],
      [
      "Today I practice staying when I speak.",
      "Not disappearing.",
      "Just being."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I rush to finish?",
      "What scares me if I stay?",
      "What happens if I stay 10 more seconds?"
    ],
      [
      "When do I rush to finish?",
      "What scares me if I stay?",
      "What happens if I stay 10 more seconds?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One more moment can change something."
    ],
      [
      "One more moment can change something."
    ]
    ),
    action: localizedGenderNode(
      "pause 10 seconds before I pull back.",
      "pause 10 seconds before I pull back."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "One word of mine",
    opening: localizedGenderNode(
      [
      "Today I choose one word of mine to share.",
      "Not much.",
      "One word."
    ],
      [
      "Today I choose one word of mine to share.",
      "Not much.",
      "One word."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my heart."
    ],
      [
      "I breathe slowly.",
      "I feel my heart."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which word wants to come out of me?",
      "Who would I like to say it to?",
      "How will it feel to say it?"
    ],
      [
      "Which word wants to come out of me?",
      "Who would I like to say it to?",
      "How will it feel to say it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One word can open a door."
    ],
      [
      "One word can open a door."
    ]
    ),
    action: localizedGenderNode(
      "write the word and remember it.",
      "write the word and remember it."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "One request",
    opening: localizedGenderNode(
      [
      "Today I form one small request.",
      "Not a demand.",
      "A request."
    ],
      [
      "Today I form one small request.",
      "Not a demand.",
      "A request."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What would I like to ask for gently?",
      "How can I say it softly?",
      "What is a small step toward it?"
    ],
      [
      "What would I like to ask for gently?",
      "How can I say it softly?",
      "What is a small step toward it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can shift the pace."
    ],
      [
      "One request can shift the pace."
    ]
    ),
    action: localizedGenderNode(
      "write the request in one sentence.",
      "write the request in one sentence."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Feeling heard",
    opening: localizedGenderNode(
      [
      "Today I ask what makes me feel heard.",
      "Small.",
      "But important."
    ],
      [
      "Today I ask what makes me feel heard.",
      "Small.",
      "But important."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I am here."
    ],
      [
      "I breathe slowly.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How does it feel when I am truly listened to?",
      "What would I like to receive there?",
      "What small step could help?"
    ],
      [
      "How does it feel when I am truly listened to?",
      "What would I like to receive there?",
      "What small step could help?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Feeling heard is a real need."
    ],
      [
      "Feeling heard is a real need."
    ]
    ),
    action: localizedGenderNode(
      "write one word about what I need to hear.",
      "write one word about what I need to hear."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "One value in connection",
    opening: localizedGenderNode(
      [
      "Today I look for one value I bring to connection.",
      "Small.",
      "But true."
    ],
      [
      "Today I look for one value I bring to connection.",
      "Small.",
      "But true."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which value matters to me in connection?",
      "How does that value look on an ordinary day?",
      "What small step could honor it?"
    ],
      [
      "Which value matters to me in connection?",
      "How does that value look on an ordinary day?",
      "What small step could honor it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One value is a thread of presence."
    ],
      [
      "One value is a thread of presence."
    ]
    ),
    action: localizedGenderNode(
      "one word that expresses the value.",
      "one word that expresses the value."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Listening to myself too",
    opening: localizedGenderNode(
      [
      "Today I practice listening to myself too.",
      "Not only to others.",
      "Also to me."
    ],
      [
      "Today I practice listening to myself too.",
      "Not only to others.",
      "Also to me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my heart."
    ],
      [
      "I breathe slowly.",
      "I feel my heart."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need to hear from myself today?",
      "What do I give others that I don't give me?",
      "How can I give it to myself?"
    ],
      [
      "What do I need to hear from myself today?",
      "What do I give others that I don't give me?",
      "How can I give it to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Listening to myself is a small repair."
    ],
      [
      "Listening to myself is a small repair."
    ]
    ),
    action: localizedGenderNode(
      "one gentle sentence to myself.",
      "one gentle sentence to myself."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A small step of reciprocity",
    opening: localizedGenderNode(
      [
      "Today I choose a small step of reciprocity.",
      "No drama.",
      "A small step."
    ],
      [
      "Today I choose a small step of reciprocity.",
      "No drama.",
      "A small step."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ],
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small step is enough to move."
    ],
      [
      "A small step is enough to move."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step and remember it.",
      "choose one small step and remember it."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return sentence",
    opening: localizedGenderNode(
      [
      "Today I choose a sentence that brings me back to reciprocity.",
      "When I forget myself.",
      "A small sentence."
    ],
      [
      "Today I choose a sentence that brings me back to reciprocity.",
      "When I forget myself.",
      "A small sentence."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about my listening?",
      "What is the first sign I disappear?",
      "Which sentence brings me back a moment before?"
    ],
      [
      "What did I learn about my listening?",
      "What is the first sign I disappear?",
      "Which sentence brings me back a moment before?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can listen to others and still stay with myself."
    ],
      [
      "I can listen to others and still stay with myself."
    ]
    ),
    action: localizedGenderNode(
      "say the new sentence once.",
      "say the new sentence once."
    ),
  },
].map(buildNormalizedDay);

export const iMAlwaysTheOneWhoListensToEveryoneButWhoListensToMeBlueprintEn = buildNormalizedPilotBlueprint({
  id: "i_m_always_the_one_who_listens_to_everyone_but_who_listens_to_me_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "i_m_always_the_one_who_listens_to_everyone_but_who_listens_to_me",
  category: "loneliness_belonging",
  journeyName: {
    he: "אני תמיד זה שמקשיב לכולם - אבל מי מקשיב לי?",
    en: "I'm always the one who listens to everyone - but who listens to me?",
    es: "Siempre soy quien escucha a todos - ¿pero quién me escucha a mí?",
  },
  days,
});

export default iMAlwaysTheOneWhoListensToEveryoneButWhoListensToMeBlueprintEn;
